export const TEN_MB = 10485760;
